import EditIcon from "@mui/icons-material/Edit";
import { Button } from "@mui/material";

import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import {
  type BlDetailSectionItem,
  DetailSection,
} from "Shared/Sections/DetailSection";

interface Partner {
  partnerID: string;
  companyName: string;
}

interface ModuleAvailablePartnersProps {
  partners: Partner[];
  onEdit: () => void;
}

export const ModuleAvailablePartners = ({
  partners,
  onEdit,
}: ModuleAvailablePartnersProps): React.ReactNode => {
  const { t } = useResource();
  const navigate = useAppNavigate();

  const items: BlDetailSectionItem[] = partners.map((partner) => ({
    id: partner.partnerID,
    label: {
      text: partner.companyName,
      onClick: () =>
        navigate(AppRouting.PartnerDetail.path(partner.partnerID), {
          state: { from: location },
        }),
    },
  }));

  return (
    <DetailSection
      title={t(Resources.Modules.ModuleDetail.AvailablePartners)}
      action={
        <Button
          variant="text"
          color="primary"
          startIcon={<EditIcon />}
          onClick={onEdit}
          sx={{ fontSize: "16px", textTransform: "none" }}
        >
          {t(Resources.Modules.ModuleDetail.EditAvailablePartners)}
        </Button>
      }
      items={items}
      emptyMessage={t(Resources.Modules.ModuleDetail.NoPartners)}
    />
  );
};
